import React from 'react';
import styled from 'styled-components'
import { useTitle } from '../../../shared/hooks/useTitle';
import hamburger128 from '../../../asset/gnb/hamburger_128.png';
import LnbLogoUsernameMobile from './LeftLogoUsernameMobile';
import BigMenuMobile from './BigMenuMobile';
import { useMenu } from '../../../shared/hooks/useMenu';
import { useArchiveNav } from '../../../shared/hooks/page/useArchiveNav';
import { paperTextureMobile } from '../../../shared/component/paperTexture';

export type { NavItem } from '../../../shared/hooks/page/useArchiveNav';

const LeftNavBarMobile: React.FC = () => {
  const { canShow, isVisible, pageOwner, isOwner, navItems } = useArchiveNav();
  const { isMenuOpen, openMenu, closeMenu } = useMenu();
  useTitle();

  if (!canShow || !pageOwner) return null;

  return (
    <>
      <LnbSection>
        {isMenuOpen ?
          <>
            <LnbMenuContainer $isActive={isVisible}>
              <LnbLogoUsernameMobile isHovered={isMenuOpen} />
              {navItems.map((item) =>
                (item.isVisible || isOwner) && (
                  <BigMenuMobile
                    key={item.path}
                    data={item}
                  />
                )
              )}
            {isOwner &&
            <BigMenuMobile
              data={
                {
                  path: `/@${pageOwner.handle}/settings`,
                  label: "Settings",
                  isVisible: true
                }
              } />}
            </LnbMenuContainer>
          </>
          :
          <HamburgerIconBtnWrapper onClick={openMenu}>
            <HamburgerIconBtn $backgroundImg={hamburger128} />
          </HamburgerIconBtnWrapper>
        }
      </LnbSection>
      {isMenuOpen && <TransparentLayer onClick={closeMenu} />}
    </>
  )
}

// ... existing code ...
const LnbSection = styled.section`
  position: fixed;
  top: clamp(18px, 5vw, 24px);
  left: clamp(14px, 4vw, 20px);

  width: 85%;
  
  display: flex;
  align-items: center;
  gap: 1vw;
  background-color: transparent;

  user-select: none;
  z-index: 6; /* 모바일 네비게이션가 펼쳐졌을 때: 모달(4-5)보다 위에서 동작 */
`;

const LnbMenuContainer = styled.div<{ $isActive: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  pointer-events: ${({ $isActive }) => $isActive ? 'auto' : 'none'};
  opacity: ${({ $isActive }) => $isActive ? 1 : 0};
  transition: opacity 0.4s ease;
`;

const TransparentLayer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  ${paperTextureMobile}
  border-radius: 0px;
  border: none;
  z-index: 5; /* 모바일 네비게이션 배경 레이어: 컨텐츠 위, LnbSection(6) 아래 */
`;

const HamburgerIconBtnWrapper = styled.article`
  padding: 5px;
  padding-left: 6px;
  cursor: pointer;
`;

const HamburgerIconBtn = styled.div<{ $backgroundImg: string}>`
  width: clamp(10px, 1.5vw, 16px);
  height: clamp(10px, 1.5vw, 16px);
  background-image: url(${({ $backgroundImg }) => $backgroundImg});
  background-size: cover;
  background-position: center;
`

export default LeftNavBarMobile;
